// Always-visible side TOC for long legal docs. Scans the rendered .prose <h2>s,
// assigns stable ids, builds a sticky list, and scrollspy-highlights the section
// in view. No-op unless the page has a [data-legal-toc] aside.
(function () {
  'use strict';

  var aside = document.querySelector('[data-legal-toc]');
  if (!aside) return;
  var prose = document.querySelector('.legal-layout__main .prose') || document.querySelector('.prose');
  if (!prose) return;

  var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
  if (heads.length < 2) { aside.hidden = true; return; } // not worth a TOC

  function slug(t) {
    return (t || 'section').toLowerCase().replace(/[^\w]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }

  var used = {};
  var list = document.createElement('ol');
  list.className = 'legal-toc__list';

  heads.forEach(function (h) {
    var id = h.id;
    if (!id) {
      id = slug(h.textContent);
      while (used[id]) id += '-x';
      h.id = id;
    }
    used[id] = true;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'legal-toc__link';
    a.href = '#' + id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  aside.appendChild(list);

  // Scrollspy — mark the section currently in view.
  if ('IntersectionObserver' in window) {
    var byId = {};
    Array.prototype.forEach.call(aside.querySelectorAll('.legal-toc__link'), function (l) {
      byId[l.getAttribute('href').slice(1)] = l;
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        Object.keys(byId).forEach(function (k) { byId[k].removeAttribute('aria-current'); });
        if (byId[e.target.id]) byId[e.target.id].setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
    heads.forEach(function (h) { obs.observe(h); });
  }
})();
